import { computed } from 'vue';
import { resolvePath } from '../api/resolvePath';
import { useRouteContext } from '../hooks/useOutlet';
import { useComputedCallback } from '../utils/useComputedCallback';
export const useResolvedPath = (toValue) => {
    const to = useComputedCallback(toValue);
    const context = useRouteContext();
    return computed(() => resolvePath(to.value, context.pathname));
};
